import Hero from './components/heropage/hero';
import './style/global.scss';
import divisor from './assets/divisor.svg';
import Brandspage from './components/brands/brands-page';
import Prevideos from './components/Videos-page/videos-page';
import Videos from './components/Videos/videos';
import FAQpage from './components/FAQ-page/FAQ-page';
import FAQ from './components/Faq/Faq';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <div className='App--div'>
        <Hero />
      </div>
      <div style={{ width: '100%',  zIndex: '9', position: 'relative',}}>
        <img src={divisor} alt='divisor icon' style={{ width: '100%',}} />
      </div>
      <Brandspage />
      <Prevideos />
      <Videos />
      <FAQpage />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;
